import React from "react";
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute:React.FC<any> = () => {
	let auth = {'token':true}
return (
    auth.token ? <Outlet/> : <Navigate to='/'/>
  );
}
export default PrivateRoute;